import { getInitialState } from './reducer';
import { createSelector } from 'reselect';
export var selectBuildsDomain = function (state) {
    return (state && state.build) || getInitialState();
};
export var makeSelectBuilds = createSelector(selectBuildsDomain, function (_a) {
    var builds = _a.builds;
    return builds;
});
export var makeSelectBuildError = function () {
    return createSelector(selectBuildsDomain, function (_a) {
        var buildError = _a.buildError;
        return buildError;
    });
};
export var makeSelectBuildsLoading = createSelector(selectBuildsDomain, function (_a) {
    var builds_loading = _a.builds_loading;
    return builds_loading;
});
export var makeSelectPublishedDates = createSelector(selectBuildsDomain, function (_a) {
    var publishedDates = _a.publishedDates;
    return publishedDates;
});
export var makeSelectPublishedDatesLoading = createSelector(selectBuildsDomain, function (_a) {
    var publishedDates_loading = _a.publishedDates_loading;
    return publishedDates_loading;
});
